export class DynamicImageSet {

  public constructor(init?: Partial<DynamicImageSet>) {
    Object.assign(this, init);
  }

  id: string = '';
  viewport: string = '';
  model: string = '';
  resolution: string = '';
  previewAngles: any[] = [];
  version: string = '';

  width: any;
  height: any;
}
